import { SET_COUNTRY_ISO_DICTIONARY, SET_SOURCE_GEO } from "./actions";

export default {
  [SET_SOURCE_GEO](state, payload) {
    state.sourceGeo = payload;
  },
  [SET_COUNTRY_ISO_DICTIONARY](state, payload) {
    state.isoCountries = payload;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};
